export default __webpack_public_path__ + "static/media/Kraken.6107bbe3.png";